<template>
  <div  class="col-auto col-lg-3 col-xl-2 mb-2">
      <div style="cursor: pointer;" class="faqWebItem rounded p-1 py-lg-3"  :class="selected.id == category.id? 'active' : ''"
      @click="selectCat(category)">
      <div class="d-flex align-items-center flex-lg-column text-center">
        <div class="iconContainer">
          <span class="bg-secondary p-2 rounded-circle d-inline-block me-2 me-lg-0 mb-lg-2">
            <i class="fa-lg fa-fw text-default" :class="category.acf.icon"></i>
          </span>
        </div>
        <div>
          <strong v-html="category.name"></strong>
        </div>
      </div>
    </div>
    </div>
</template>
<script>


export default {

    props: { category: { type: Object }, selectCat: { type: Function }, selected: {type: Object} },
}
</script>
